import React from 'react';
import classNameBind from 'classnames/bind';
import { useTranslation } from '../Translator';
import Popover from '../Popover';
import WebsiteSelect from './components/WebsiteSelect';
import styles from './WebsitePicker.module.css';
import { PickerButton } from '../PickerButton';
import getTypeIcon from './getTypeIcon';
import * as Types from './types';

const bindClasses = classNameBind.bind(styles);
const dataId = 'WebsitePicker';

const WebsitePicker = ({
  websites,
  pagination,
  withTypesFilter,
  selected,
  onWebsiteSelected,
  fullWidth,
}) => {
  const { t } = useTranslation('components');

  return (
    <div className={bindClasses('wrapper', { fullWidth })} data-ppuc-id={dataId}>
      <Popover
        activatorElement={(
          <PickerButton
            icon={{
              type: 'icon',
              content: getTypeIcon(selected ? selected.type : null),
            }}
            dataId={dataId}
          >
            {selected === null
              ? t('WebsitePicker.no-value-selected')
              : selected.attributes.name
            }
          </PickerButton>
        )}
        speechBubble
        position={fullWidth ? 'bottom' : 'bottom-end'}
        childToggle={{ onWebsiteSelected: () => true }}
        dataId="WebsitePicker"
        focusOrder={['content']}
      >
        <WebsiteSelect
          websites={websites}
          pagination={pagination}
          onWebsiteSelected={onWebsiteSelected}
          withTypesFilter={withTypesFilter}
        />
      </Popover>
    </div>
  );
};

WebsitePicker.defaultProps = {
  selected: null,
  pagination: {
    onLoadItems: () => {},
    total: 0,
    limit: 0,
  },
  withTypesFilter: false,
  fullWidth: false,
};

WebsitePicker.propEnums = {
  type: [Types.all, Types.website, Types.metaSite],
};

export { WebsitePicker };
export default WebsitePicker;
